import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { Divider, notification, Skeleton } from "antd";
import { TypePlanoContas } from "../../../Models/Financeiro/PlanoContas";
import { ListagemDePlanosDeContas } from "./ListagemDePlanosDeConta";
import { CadastroDePlanoDeConta } from "./CadastroDePlanoDeConta";

import { Link, matchPath, Route, Routes, useNavigate } from "react-router-dom";
import { useRelativePath } from "../../../Hooks/useNextRelativePath";
import { useRedirection } from "../../../Hooks/useRedirection";
import { useWatchParameterOnRoutes } from "../../../Hooks/useGetParameterOnRoutes";
import { SessaoContext } from "../../../Contexts/SessaoContext";
import { useMutation } from "@tanstack/react-query";
import { PlanoContasService } from "../../../Services/Financeiro/PlanoContasService";
import { PropriedadesDeNotificacao } from "../../../Utils/Notificacoes";
import { Permissoes } from "../../../Constants/Permissoes";

export const PlanoDeContas = (props: {}): JSX.Element => {
    const [planoDeContasEmAlteracao, setPlanoDeContasEmAlteracao] = useState<TypePlanoContas | undefined>(undefined);

    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);

    const navigate = useNavigate();
    const [raiz, subrota] = useRelativePath();

    const rotaDeEdicao = matchPath({ path: "/editar" }, subrota);
    const rotaDeVisualizacao = matchPath({ path: "/detalhes" }, subrota);

    const obterPlanoDeContas = useMutation({
        mutationFn: (id: number) => new PlanoContasService().listar({ codigo: id, ativo: true }),
        onSuccess: (resposta) => {
            const resultados = resposta.data;
            if (resultados.length == 0) {
                notification.open({
                    ...PropriedadesDeNotificacao.Erro("Nenhum registro foi encontrado para o identificador informado")
                })
                navigate(raiz)
            } else {
                setPlanoDeContasEmAlteracao(resposta.data.at(0))
            }
        }
    })

    useRedirection([Permissoes.ListarPlanosDeContas, Permissoes.CriarPlanoDeContas, Permissoes.AtualizarPlanoDeContas, Permissoes.DesativarPlanoDeContas])
    useWatchParameterOnRoutes({ 
        appliablePaths: [rotaDeEdicao, rotaDeVisualizacao], paramToWatch: "id", filters: [(p) => isNaN(Number(p))], 
        onNotAccepted() { navigate(raiz) },
        onExists(param) { obterPlanoDeContas.mutate(Number(param)); }, 
     })

    return ( 
        <>
            <h2 style={{ marginTop: 0 }}> 
                {
                    rotaDeVisualizacao ? "Detalhes do Plano de Contas" : rotaDeEdicao? "Edição do Plano de Contas": "Cadastro de Plano de Contas"
                }
            </h2>

            <Divider />

            <Routes>
                {
                    permissoes?.includes(Permissoes.ListarPlanosDeContas) &&
                    <Route path="*" index element={
                        <ListagemDePlanosDeContas
                            hrefDoBotaoAdicionar={raiz + "/cadastro"}
                            hrefDoBotaoEditar={(item) => {
                                if (item.codigo) {
                                    return raiz + `/editar?id=${item.codigo}`
                                }
                            }}

                            aoEditar={(item) => {
                                setPlanoDeContasEmAlteracao(item);
                            }}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.CriarPlanoDeContas) &&
                    <Route path="/cadastro" element={
                        <CadastroDePlanoDeConta
                            aoCancelar={() => { navigate(raiz) }}
                            depoisDeFinalizar={() => { navigate(-1); } }
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.AtualizarPlanoDeContas) &&
                    <Route path="/editar" element={
                        planoDeContasEmAlteracao == undefined ? <Skeleton active /> :
                            <CadastroDePlanoDeConta
                                planoDeContasEmAlteracao={planoDeContasEmAlteracao}
                                aoCancelar={() => { navigate(raiz) }}
                                depoisDeFinalizar={() => { navigate(-1); } }
                            />
                    } />
                }
            </Routes>
            

        </>
    );
}